import React from 'react';
import { ApplicationView } from '@aha-app/mvc';
import { HighlightText, type ItemTemplateParams } from '@aha-app/selectro-v2';

interface GenericRecordItemTemplateProps {
  bottomDetails?: Array<React.ReactNode | string>;
}

const GenericRecordItemTemplate: React.FC<
  GenericRecordItemTemplateProps & ItemTemplateParams
> = ({ item, tabIndex, bottomDetails }) => {
  return (
    <div
      className='SelectroV2__text tw-flex tw-justify-between'
      data-testid='item-default-template'
      tabIndex={item.disabled ? -1 : tabIndex}
    >
      <div>
        <div>
          <HighlightText item={item} text={item.text} />
          <div className='tw-flex tw-items-center tw-gap-1'>
            {bottomDetails?.map((detail, index) => {
              return (
                <div
                  key={index}
                  className='tw-text-tertiary !tw-font-medium tw-text-[10px]'
                >
                  {typeof detail === 'string' ? (
                    <HighlightText item={item} text={detail} />
                  ) : (
                    detail
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationView(GenericRecordItemTemplate);
